var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11H39V14H9V11Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25H44V18C44 15.8 42.2 14 40 14H8C5.8 14 4 15.8 4 18V25Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 36H40C42.2 36 44 34.2 44 32V24H4V32C4 34.2 5.8 36 8 36Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19C40.5523 19 41 18.5523 41 18C41 17.4477 40.5523 17 40 17C39.4477 17 39 17.4477 39 18C39 18.5523 39.4477 19 40 19Z",
    fill: "#00E676"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4H37V14H11V4Z",
    fill: "#90CAF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 31H10.5C9.7 31 9 30.3 9 29.5C9 28.7 9.7 28 10.5 28H37.5C38.3 28 39 28.7 39 29.5C39 30.3 38.3 31 37.5 31Z",
    fill: "#242424"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 31H37V42H11V31Z",
    fill: "#90CAF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29H37V31H11V29Z",
    fill: "#42A5F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 33H33V35H16V33ZM16 37H29V39H16V37Z",
    fill: "#1976D2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/printIcon.ec3132454840923ba5355f25ee037a28.svg";
export { ForwardRef as ReactComponent };